import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators,FormGroupDirective} from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import { _ } from 'underscore';
import {Observable} from 'rxjs';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface DialogData {
  action:boolean;
  message:any;
  data:any;
}
@Component({
  selector: 'app-edit-invoice',
  templateUrl: './edit-invoice.component.html',
  styleUrls: ['./edit-invoice.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
 ],
})
export class EditInvoiceComponent implements OnInit {
  editInvoiceInfo:any={editStatus:false,data:{direct_invoice_status:0}};
  editInvoiceId:any=''
  loggedUserInfo:any=[];
  masterInvoiceData:any=[];
  productsDetails:any=[];
  invoiceForm: FormGroup;
  parties:any = []
  options:any = [];
  existingInvoiceStatus:boolean = false;
  filteredOptions: Observable<string[]>;
  catOptions: Observable<any[]>[][] = [];
  itemOptions: Observable<string[]>[][] = [];
  party_gstin:any=''
  items:any=[]
  tags:any=[]
  units:any=[];
  deletedProducts:any=[];
  selectedCategory:any=null;
  showFormStatus:boolean = false;
  arrayUnitVariableIterateSubscriber:any;
  arrayUnitVariableIterationObserver:any = new Subject<any>();
  productIterateSubscriber:any;
  productIterationObserver:any = new Subject<any>();
  deleteProductIterateSubscriber:any;
  deleteProductIterationObserver:any = new Subject<any>();
  constructor(public dialog: MatDialog,private router:Router, private observables:ObservablesService,private formBuilder: FormBuilder, private api:ApiService, private datePipe: DatePipe) {
    if(this.router.getCurrentNavigation().extras.state !== undefined){
      this.editInvoiceInfo = this.router.getCurrentNavigation().extras.state
      // console.log("editInvoiceInfo=",this.editInvoiceInfo)
    }
  }

  ngOnInit() {

    this.observables.updateProductsArrStatus.subscribe((product:any)=>{
      // console.log("added product = ",product)
      // console.log("selected category=",this.selectedCategory)
      if(this.selectedCategory){

        this.setArrayForUnitVariable(product.demoArray,product).then((arrayRes:any)=>{
          this.prepareProdcutObject(product,arrayRes,product.category_status);
          this.calculateTotalAmount()
          this.calculateGSTTotalAmount()

        })
      }
    })
    // if(this.editInvoiceInfo.data.direct_invoice_status == 0){
      this.api.getLoggedUserInfo().then((res:any)=>{
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          // console.log("loggedUserInfo=====",this.loggedUserInfo)
          this.getParty();
          this.getItem();

          if(this.loggedUserInfo.tag_subscribe_status){
            this.getTags();
          }

          this.getUnit();

        }else{
          this.api.logOut()
        }

      })

      this.createForm()
    // }

  }

  addTags(){
      this.observables.tagPopupStatus.next()
  }

  prepareProdcutObject(product,arrayRes,categoryStatus){
    let productObject:any;
    let gst_amount = parseFloat(product.amount)/100*product.gst;
    if(categoryStatus){

      productObject = {
        id:'',
        business_id: this.selectedCategory[0].business_id,
        invoice_id: this.selectedCategory[0].invoice_id,
        invoice_number: this.selectedCategory[0].invoice_number,
        party_id: this.selectedCategory[0].party_id,
        party_name: this.selectedCategory[0].party_name,
        gstin: this.selectedCategory[0].gstin,
        invoice_date: this.selectedCategory[0].invoice_date,
        user_id: this.selectedCategory[0].user_id,
        user_name: this.selectedCategory[0].user_name,
        gst_total_amount: this.selectedCategory[0].gst_total_amount,
        discount_amount: this.selectedCategory[0].discount_amount,
        total_amount: this.selectedCategory[0].total_amount,
        invoice_status: this.selectedCategory[0].invoice_status,
        direct_invoice_status: this.selectedCategory[0].direct_invoice_status,
        tags: this.selectedCategory[0].tags,
        note: this.selectedCategory[0].note,
        delivery_to: this.selectedCategory[0].delivery_to,
        created: this.selectedCategory[0].created,
        master_invoice_id: this.selectedCategory[0].master_invoice_id,
        category_id: this.selectedCategory[0].category_id,
        category_name: this.selectedCategory[0].category_name,
        product_detail_id:'',
        item_name:product.item_name,
        item_code:product.item_code,
        item_id:product.item,
        gst:product.gst,
        cess:0,
        item_description:product.description,
        rate:product.rate,
        unit:product.unit,
        unit_value:product.demoArray[product.demoArray.length - 1][product.unit],
        discount:product.discount,
        gross_amount:parseFloat(product.amount),
        sgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
        cgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
        igst:(this.loggedUserInfo.gstin.substring(0,2) != this.party_gstin.substring(0,2))?gst_amount:0,
        net_amount:parseFloat(product.amount) + gst_amount,

      }
    }else{
      // console.log("productsDetails=====",this.productsDetails)
      productObject = {
        id:'',
        business_id: this.productsDetails[0][0].business_id,
        invoice_id: this.productsDetails[0][0].invoice_id,
        invoice_number: this.productsDetails[0][0].invoice_number,
        party_id: this.productsDetails[0][0].party_id,
        party_name: this.productsDetails[0][0].party_name,
        gstin: this.productsDetails[0][0].gstin,
        invoice_date: this.productsDetails[0][0].invoice_date,
        user_id: this.productsDetails[0][0].user_id,
        user_name: this.productsDetails[0][0].user_name,
        gst_total_amount: this.productsDetails[0][0].gst_total_amount,
        discount_amount: this.productsDetails[0][0].discount_amount,
        total_amount: this.productsDetails[0][0].total_amount,
        invoice_status: this.productsDetails[0][0].invoice_status,
        direct_invoice_status: this.productsDetails[0][0].direct_invoice_status,
        tags: this.productsDetails[0][0].tags,
        note: this.productsDetails[0][0].note,
        delivery_to: this.productsDetails[0][0].delivery_to,
        created: this.productsDetails[0][0].created,
        master_invoice_id: this.productsDetails[0][0].master_invoice_id,
        category_id: product.category_id,
        category_name: product.category_name,
        product_detail_id:'',
        item_name:product.item_name,
        item_code:product.item_code,
        item_id:product.item,
        gst:product.gst,
        cess:0,
        item_description:product.description,
        rate:product.rate,
        unit:product.unit,
        unit_value:product.demoArray[product.demoArray.length - 1][product.unit],
        discount:product.discount,
        gross_amount:parseFloat(product.amount),
        sgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
        cgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
        igst:(this.loggedUserInfo.gstin.substring(0,2) != this.party_gstin.substring(0,2))?gst_amount:0,
        net_amount:parseFloat(product.amount) + gst_amount,

      }
    }

    if(categoryStatus){

      this.selectedCategory.push(this.prepareObject([productObject,this.prepareObject(arrayRes.variables)]))
      // this.selectedCategory = null
    }else{
      this.productsDetails.push([this.prepareObject([productObject,this.prepareObject(arrayRes.variables)])])
    }
  }

  prepareObject(arr){
    return arr.reduce(function(result, currentObject) {
        for(var key in currentObject) {
            if (currentObject.hasOwnProperty(key)) {
                result[key] = currentObject[key];
            }
        }
        return result;
    }, {});
  }

  setArrayForUnitVariable(unitVariableArray,product){
    return new Promise((resolve,reject)=>{

      let a = 0
      let variables = []
      this.arrayUnitVariableIterateSubscriber = this.arrayUnitVariableIterationObserver.subscribe((a)=>{
        if(a>=unitVariableArray.length-1){
          this.arrayUnitVariableIterateSubscriber.unsubscribe();
          resolve({status:true,variables_status:true,variables:variables})

        }else{
          variables.push({product_variable_id:'',['col_'+(a+1)]:unitVariableArray[a].key,['col_'+(a+1)+'_value']:unitVariableArray[a][unitVariableArray[a].key]})

          this.arrayUnitVariableIterationObserver.next(a+1);
        }

      })

      this.arrayUnitVariableIterationObserver.next(a);
    })
  }

  createForm(){
    this.editInvoiceId = this.editInvoiceInfo.data.invoice_id;
    this.getmasterInvoiceData(this.editInvoiceId).then((resp:any)=>{
      // console.log("response==",resp);
      if(resp.data.length > 0){
        this.showFormStatus = true;
        this.masterInvoiceData = resp.data
        this.party_gstin = this.masterInvoiceData[0].gstin;
        this.invoiceForm = this.formBuilder.group({
          invoice_number:[{value:this.masterInvoiceData[0].invoice_number,disabled:true}, Validators.compose([Validators.required,Validators.pattern(/^[0-9]{1,6}$/)])],
          party_id:this.masterInvoiceData[0].party_id,
          user_id:this.masterInvoiceData[0].user_id,
          party_name:this.masterInvoiceData[0].party_name,
          invoice_date:{value:new Date(this.masterInvoiceData[0].invoice_date),disabled:true},
          delivery_to:this.masterInvoiceData[0].delivery_to,
          total_amount: [this.masterInvoiceData[0].total_amount,Validators.required],
          gst_total_amount:this.masterInvoiceData[0].gst_total_amount,
          // categories: this.formBuilder.array([this.categories]),
          tags:[(this.masterInvoiceData[0].tags)?JSON.parse(this.masterInvoiceData[0].tags).map(item=>item.tag_id):null],
          note:this.masterInvoiceData[0].note
        });

        if(this.editInvoiceInfo.data.direct_invoice_status == 0){

          let groups = _.groupBy(this.masterInvoiceData,"category_id");
          // console.log("master value==",_.values(groups));
          this.productsDetails = _.values(groups)
          this.calculateTotalAmount()
          this.calculateGSTTotalAmount()
        }
      }
    })
  }

  getmasterInvoiceData(invoice_id){
    return new Promise((resolve)=>{

      this.api.send("findDb",{
        table:'master_invoices as M',
        fields:["M.*","P.*"],
        joins:[{
          type:'left',
          table:'master_invoice_products as P',
          conditions:['P.master_invoice_id = M.id']
        }],
        conditions:[{"M.invoice_id":invoice_id}]
      }).then((res:any)=>{
        resolve(res)
      })
    })
  }

  checkInvoiceNo(value){


    if(value.length > 0){
      let data={
        invoice_number:value,
        business_id:this.loggedUserInfo.business_id
      }

      this.api.send("findDb",{
        table:"invoices",
        conditions:[data]
      }).then((result:any)=>{
        // console.log("Invoice No==",result)
        if(result.data.length > 0){

          this.existingInvoiceStatus = true;
          // resolve(true)
        }else{
          this.existingInvoiceStatus = false;
          // resolve(false)
        }
      })
    }else{
      this.existingInvoiceStatus = false;
      // resolve(false)
    }
    // })

  }

  getParty(){

   this.api.send("findDb",{
     table:"parties",
     conditions:[{business_id:this.loggedUserInfo.business_id}],
     order:"id DESC"
   }).then((result:any)=>{
     // console.log("results=",result)
     this.parties = result.data;
     this.options = result.data;

     this.filteredOptions = this.invoiceForm.get('party_name').valueChanges
     .pipe(
       startWith(''),
       map(value => this._filter(value))
     );
   });

  }

  private _filter(value: any): string[] {
    if(value){

      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.business_name.toLowerCase().includes(filterValue));
    }
  }


  onSelectionChanged(_event: any,userData) {

    if (_event.isUserInput) {
      // console.log("userData=",userData)
      this.invoiceForm.patchValue({party_id:userData.id,user_id:userData.user_id})
      this.party_gstin = userData.gstin;
    }

  }

  getItem(){
    this.items= []
     this.api.send("findDb",{
       table:"items as I",
       fields:["U.name as unit","U.id as unit_id","UV.name as unit_variable","IU.unit_variable_id","I.*"],
       joins:[{
         type:'left',
         table:'item_unit_variables as IU',
         conditions:["IU.item_id = I.id"]
       },{
         type:'left',
         table:'unit_variables as UV',
         conditions:["UV.id = IU.unit_variable_id"]
       },{
         type:'left',
         table:'units as U',
         conditions:["U.id = I.unit_id"]
       }],
       conditions:[{"I.business_id":this.loggedUserInfo.business_id}]
     }).then((result:any)=>{
       let group = _.groupBy(result.data,'id')
       let value = _.values(group);

       value.filter((item)=>{
        if(item.length > 1){
          let unit_variables=[]

          for(let i=0;i<item.length;i++){
            unit_variables.push({unit_variable:item[i].unit_variable,unit_variable_id:item[i].unit_variable_id})

            if(i == item.length -1){

              this.items.push({
                business_id: item[0].business_id,
                cess: item[0].cess,
                discount: item[0].discount,
                gst: item[0].gst,
                id: item[0].id,
                name: item[0].name,
                item_code:item[0].item_code,
                rate: item[0].rate,
                unit:item[0].unit,
                unit_id:item[0].unit_id,
                unit_variables: unit_variables,
                unit_variable_name:Array.prototype.map.call(unit_variables, s => s.unit_variable).toString()
                // unit_id:item[0].unit_id
              })
            }
          }
        }else{

          this.items.push({
            business_id: item[0].business_id,
            cess: item[0].cess,
            discount: item[0].discount,
            gst: item[0].gst,
            id: item[0].id,
            name: item[0].name,
            item_code:item[0].item_code,
            rate: item[0].rate,
            unit:item[0].unit,
            unit_id:item[0].unit_id,
            unit_variables: [{unit_variable:item[0].unit_variable,unit_variable_id:item[0].unit_variable_id}],
            unit_variable_name:item[0].unit_variable
          })
        }
     })

   })
  }
  getTags(){
   this.api.send("findDb",{
     table:"tags",
     conditions:[{business_id:this.loggedUserInfo.business_id}]
   }).then((result:any)=>{
     this.tags=result.data
   })
  }

  getTag(tag_id){
    for(let i=0;i<this.tags.length;i++){
      if(this.tags[i].id == tag_id){
        return this.tags[i].tag_name
      }
    }
  }

  getUnit(){
    this.api.send('findDb',{
      table:'units'
    }).then((res:any)=>{
      this.units = res.data;
    })
  }

  getnum(value){
    return parseFloat(value)
  }

  cancelUpdate(){
    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
  }

  updateInvoice(value,formDirective){
    // console.log("invoice form data=",this.invoiceForm.getRawValue());
    // console.log("product details==",this.productsDetails)
    value = this.invoiceForm.getRawValue();

    let concatArr = this.productsDetails.reduce((a, b) => [...a, ...b], []);
    // console.log("concated array=",concatArr);
      let date:any = new Date(value.invoice_date);
      let invoice_date:any=this.datePipe.transform(date, 'yyyy-MM-dd'); //whatever format you need.
      let tags = []
      if(value.tags) {
        value.tags.filter(item=>{
          for(let i=0;i<this.tags.length;i++){
            if(item == this.tags[i].id){
              tags.push({tag_id:this.tags[i].id,tag:this.tags[i].tag_name})
              break;
            }
          }
        })
      }
      this.api.send('updateDb',{
        table:'master_invoices',
        data:{
          invoice_number:value.invoice_number,
          party_id:value.party_id,
          party_name:value.party_name,
          gstin:this.party_gstin,
          invoice_date:invoice_date,
          user_id:this.editInvoiceInfo.data.user_id,
          user_name:this.loggedUserInfo.username,
          gst_total_amount:value.gst_total_amount,
          exclude_gst_total_amount:value.total_amount,
          total_amount:parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          balance:parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          note:value.note,
          delivery_to:value.delivery_to,
          tags:(tags.length)?JSON.stringify(tags):null
        },
        conditions:[{invoice_id:this.editInvoiceId}]
      }).then((res:any)=>{
        if(res.data.affectedRows){
          if(this.editInvoiceInfo.direct_invoice_status){
            this.observables.showToastMessage({type:0,message:'Invoice Updated...'});
            this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
          }else{

            this.updateMasterProductDetails(value,concatArr).then((result:any)=>{

              this.observables.showToastMessage({type:0,message:'Invoice Updated...'});
              this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
            })
          }
        }
      })

  }

  updateMasterProductDetails(vlaue,productArr){
    return new Promise((resolve,reject)=>{

      let a = 0
      this.productIterateSubscriber = this.productIterationObserver.subscribe((a)=>{
        if(a>=productArr.length){
          if(this.deletedProducts.length > 0){
            this.productIterateSubscriber.unsubscribe();
            this.deleteMasterProducts().then((resp:any)=>{
              this.deletedProducts = []
              resolve(true)
            })
          }else{
            resolve(true)
          }

        }else{
          let omitData = [
            "id",
            "business_id",
            "invoice_id",
            "invoice_number",
            "party_id",
            "party_name",
            "gstin",
            "invoice_date",
            "user_id",
            "user_name",
            "gst_total_amount",
            "discount_amount",
            "exclude_gst_total_amount",
            "total_amount",
            "invoice_status",
            "direct_invoice_status",
            "tags",
            "note",
            "delivery_to",
            "balance",
            "slip_status",
            "paid_amt",
            "delete_status",
            "paid_status",
            "created"
          ]
          // console.log("omit data=",_.omit(productArr[a],omitData))

          if(productArr[a].id != ''){

            this.api.send("updateDb",{
              table:'master_invoice_products',
              data:_.omit(productArr[a],omitData),
              conditions:[{id:productArr[a].id}]
            }).then((result:any)=>{
              if(result.data.affectedRows){
                this.productIterationObserver.next(a+1);
              }
            })
          }else{
            // delete productArr[a].id
            if(productArr[a].category_id != ''){
              this.api.send("insertDb",{
                table:'master_invoice_products',
                data:_.omit(productArr[a],omitData)
              }).then((result:any)=>{
                if(result.data.affectedRows){
                  this.productIterationObserver.next(a+1);
                }
              })
            }else{
              this.api.send("insertDb",{
                table:"categories",
                data:{
                  category_name:productArr[a].category_name,
                  invoice_id:productArr[a].invoice_id
                }
              }).then((catRes:any)=>{
                if(catRes.data.affectedRows){
                  let updatedData = _.omit(productArr[a],omitData);
                  updatedData.category_id = catRes.data.insertId;
                  this.api.send("insertDb",{
                    table:'master_invoice_products',
                    data:updatedData
                  }).then((result:any)=>{
                    if(result.data.affectedRows){
                      this.productIterationObserver.next(a+1);
                    }
                  })
                }
              })
            }
          }
        }

      })

      this.productIterationObserver.next(a);
    })
  }

  calculateTotalAmount(){
    let total = 0;

    for(let i =0;i<this.productsDetails.length;i++){
      total = total + this.productsDetails[i].reduce( ( accumulator, currentValue ) => {
        return accumulator + parseFloat(currentValue.gross_amount);
      }, 0);

      this.invoiceForm.patchValue({total_amount:total.toFixed(3)})
    }

  }
  calculateGSTTotalAmount(){
    let total = 0;

    for(let i =0;i<this.productsDetails.length;i++){
      total = total + this.productsDetails[i].reduce( ( accumulator, currentValue ) => {

        return accumulator + (currentValue.gross_amount*currentValue.gst)/100;

      }, 0);

      this.invoiceForm.patchValue({gst_total_amount:total.toFixed(3)});

    }

  }

  deleteMasterProducts(){
    return new Promise((resolve)=>{
      let a = 0
      this.deleteProductIterateSubscriber = this.deleteProductIterationObserver.subscribe((a)=>{
        if(a>=this.deletedProducts.length){

          resolve(true)

        }else{
          this.api.send("deleteDb",{
            table:"master_invoice_products",
            conditions:[{id:this.deletedProducts[a]}]
          }).then((result:any)=>{
            if(result.data.affectedRows){
              this.deleteProductIterationObserver.next(a+1);
            }
          })

        }

      })

      this.deleteProductIterationObserver.next(a);

    })
  }


  deleteCategory(i,category){
    // console.log("i =",i)
    // console.log("category details==",category)

    this.deletedProducts.push(Object.values(category).filter((item:any)=>{if(item.id!=''){ return item.id}}).map((item1:any)=>item1.id))
    this.productsDetails.splice(i, 1);
    this.calculateTotalAmount()
    this.calculateGSTTotalAmount()
  }
  deleteProduct(i,j,product){
    // console.log("i = j =",i+"="+j)
    // this.deletedProducts.push(product)
    // console.log("product details==",product)
    if(product.id != ''){
      this.deletedProducts.push(product.id)
    }

    this.productsDetails[i].splice(j, 1)
    this.calculateTotalAmount()
    this.calculateGSTTotalAmount()
  }

  calculateTotal(variable,event,i,j,product,category,unitVariableStatus){
    // console.log(event.target.value)
    if(unitVariableStatus){
      if(event.target.value == '' || event.target.value == '00'){


          product["col_"+variable+"_value"] = 0

      }else{
        event.target.value = event.target.value.replace(/^0+/, '')
      }

      if(variable == 1){
        product.unit_value = parseFloat(product.col_1_value)
      }else if(variable == 2){
        product.unit_value = parseFloat(product.col_1_value) + parseFloat(product.col_2_value)
      }else{

        product.unit_value = parseFloat(product.col_1_value) + parseFloat(product.col_2_value) + parseFloat(product.col_3_value)
      }

      let amount = parseFloat(product.unit_value) * parseFloat(product.rate)
      let discount_amount = (amount/100)*product.discount
      product.gross_amount = amount - discount_amount
    }else{
      if(event.target.value == '' || event.target.value == '00'){
        if(variable == 'rate'){
          product[variable] = 0
        }else if(variable == 'discount'){
          product[variable] = 0
        }
      }else{
        event.target.value = event.target.value.replace(/^0+/, '')
      }
      let amount = parseFloat(product.unit_value) * parseFloat(product.rate)
      let discount_amount = (amount/100)*product.discount
      product.gross_amount = amount - discount_amount

    }

    this.calculateTotalAmount()
    this.calculateGSTTotalAmount()
  }


  addCategory(){
    this.addProduct(false,true)
  }

  addProduct(productStatus = true,category=null){
    this.selectedCategory = category;
    let dialogConfig:any;

      dialogConfig = {
        panelClass: 'product-popup',
        width: '100vw',
        height: '80vh',
        data: {action:productStatus,data:this.loggedUserInfo,message:"Add Product"}
      }

   const dialogRef = this.dialog.open(AddInvoiceRecordPopupComponent,dialogConfig);

   dialogRef.afterClosed().subscribe(result => {
     // console.log(`Dialog result: ${result}`);

   });
  }

}

@Component({
  selector: 'app-add-record-popup',
  templateUrl: '../add-record-popup/add-record-popup.component.html'
})
export class AddInvoiceRecordPopupComponent {
  slipForm: FormGroup;
  items:any=[]
  loggedUserInfo:any=[]
  options:any = []
  addCategoryStatus:boolean = false;
  filteredOptions: Observable<string[]>;
  constructor(private formBuilder:FormBuilder, private observables:ObservablesService, private fb:FormBuilder, private api:ApiService,public dialog: MatDialog,public dialogRef: MatDialogRef<AddInvoiceRecordPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    ngOnInit() {
      this.addCategoryStatus = this.data.action;
      this.loggedUserInfo = this.data.data;
      this.slipForm = this.formBuilder.group({
        product_id:'',
        category_name:'',
        category_id:'',
        category_status:this.addCategoryStatus,
        item_name: [null, Validators.required],
        item_code: [null],
        item: [null, Validators.required],
        description:[null],
        demoArray: this.formBuilder.array([]),
        rate:[null, Validators.required],
        amount: [{value:0,disabled:true}, Validators.required],
        unit_id:[null],
        unit:[null],
        discount:[null],
        gst:[null, Validators.required]
      });
      this.getItem();
    }


      getItem(){
        this.items= []
         this.api.send("findDb",{
           table:"items as I",
           fields:["U.name as unit","U.id as unit_id","UV.name as unit_variable","IU.unit_variable_id","I.*"],
           joins:[{
             type:'left',
             table:'item_unit_variables as IU',
             conditions:["IU.item_id = I.id"]
           },{
             type:'left',
             table:'unit_variables as UV',
             conditions:["UV.id = IU.unit_variable_id"]
           },{
             type:'left',
             table:'units as U',
             conditions:["U.id = I.unit_id"]
           }],
           conditions:[{"I.business_id":this.loggedUserInfo.business_id}]
         }).then((result:any)=>{
           let group = _.groupBy(result.data,'id')
           let value = _.values(group);

           value.filter((item)=>{
            if(item.length > 1){
              let unit_variables=[]

              for(let i=0;i<item.length;i++){
                unit_variables.push({unit_variable:item[i].unit_variable,unit_variable_id:item[i].unit_variable_id})

                if(i == item.length -1){

                  this.items.push({
                    business_id: item[0].business_id,
                    cess: item[0].cess,
                    discount: item[0].discount,
                    gst: item[0].gst,
                    id: item[0].id,
                    name: item[0].name,
                    item_code:item[0].item_code,
                    rate: item[0].rate,
                    unit:item[0].unit,
                    unit_id:item[0].unit_id,
                    unit_variables: unit_variables,
                    unit_variable_name:Array.prototype.map.call(unit_variables, s => s.unit_variable).toString()
                    // unit_id:item[0].unit_id
                  })

                  this.options = this.items;

                  this.filteredOptions = this.slipForm.get('item_name').valueChanges
                  .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                  );


                }
              }
            }else{

              this.items.push({
                business_id: item[0].business_id,
                cess: item[0].cess,
                discount: item[0].discount,
                gst: item[0].gst,
                id: item[0].id,
                name: item[0].name,
                item_code:item[0].item_code,
                rate: item[0].rate,
                unit:item[0].unit,
                unit_id:item[0].unit_id,
                unit_variables: [{unit_variable:item[0].unit_variable,unit_variable_id:item[0].unit_variable_id}],
                unit_variable_name:item[0].unit_variable
              })
            }
         })

       })
      }

      private _filter(value: any): string[] {
        if(value){

          const filterValue = value.toLowerCase();
          return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
        }
      }

    onSelectionChanged(_event: any,itemData) {

      if(_event.isUserInput){

            this.slipForm.setControl('demoArray', this.formBuilder.array([]));
            const control = this.slipForm.get('demoArray') as FormArray;
            this.items.filter((item:any)=>{
              if(item.id == itemData.id){
                this.slipForm.patchValue({item:item.id,item_code:item.item_code,unit_id:item.unit_id,unit:item.unit,gst:item.gst,rate:item.rate,description:null,amount:0,discount:item.discount})
                if(itemData.unit_variables.length > 0){
                  this.manageVariableControl(itemData,control)
                }

              }
            })
            // console.log("form==",this.slipForm)
            // console.log("contorl==",control)
            // this.calculateTotalAmount()
            // this.calculateGSTTotalAmount()
          // }else{
          //   console.log("same item selected=")
          // }
      }
    }
    manageVariableControl(itemData,control){


      for(let k=0;k<itemData.unit_variables.length;k++){
        this.addItem(itemData.unit_variables[k].unit_variable,itemData.unit_variables[k].unit_variable_id,k,control)

        if(k == itemData.unit_variables.length - 1){
          this.addUnitToForm(control,itemData.unit,k+1)
          // console.log("productControl==",productControl)
        }
      }
    }


    addUnitToForm(control,item,k=0){
      control.push(this.arrayGroup({[item]:new FormControl({value:0,disabled:true}, Validators.required),key:new FormControl(`${item}`)}))
      // control[k].key = item
    }

    addItem(item,item_id,k,control) {
       // this.arrayItems.push(item);

       control.push(
         this.arrayGroup({
           product_variable_id:new FormControl(''),
           key:new FormControl(`${item}`),
           [item]:new FormControl(0, Validators.required),
           unit_variable_id:new FormControl(item_id, Validators.required)
         })
       )

       // console.log("control==",control)
       // control[k].key = item
    }

    private arrayGroup(data): FormGroup {
      return this.formBuilder.group(data);
    }

    calculateTotal(variable){
      let result = []
      // console.log("variable==",variable)
      for(let k=0;k<variable.length -1;k++){
        // console.log("values ==",variable[k].value[variable[k].value.key])
        result.push(variable[k].value[variable[k].value.key])
      }

      // console.log("result=",result)
      let abc = result.reduce( ( accumulator, currentValue ) => {
        return accumulator*currentValue
      }, 1);
      // console.log("abc=",abc)
      let demoArrayLength = variable.length;

      let unit_name:any = Object.values(variable[demoArrayLength - 1].value)[0]
      // console.log(unit_name)

      let discount = this.slipForm.get('rate').value/100*this.slipForm.get('discount').value

      let actualAmount:any = (abc*(this.slipForm.get('rate').value - discount));

      variable[demoArrayLength-1].patchValue({[unit_name]:abc.toFixed(2)})
      this.slipForm.patchValue({amount:actualAmount.toFixed(3)})
    }

    addProduct(){
      // console.log("form value=",this.slipForm.getRawValue())
      this.observables.updateProductsArrStatus.next(this.slipForm.getRawValue())
      this.dialog.closeAll()
    }

  }
